export default __webpack_public_path__ + "static/media/ugadi-srisailam.47d6f2b4.webp";